import {get, post, del, put} from '@/api';
import * as APPOINTMENT from '../constants/appointment';
import queryString from 'query-string';
import * as PATIENT from "../constants/patient";
import * as MEDICINE from "@/store/constants/medicine";

export default {
  [APPOINTMENT.ACTION_LIST_APPOINTMENTS]: ({commit}, param) => {
    const qs = queryString.stringify(param, {arrayFormat: 'bracket'});
    console.log(`/appointment?${qs}`);
    const promiseResult = get(`/appointment?${qs}`);

    promiseResult.then((res) => {
      commit(APPOINTMENT.MUTATE_LIST_APPOINTMENT, res.data);
    });

    return promiseResult;
  },

  [APPOINTMENT.ACTION_GET_APPOINTMENT]: ({commit}, id) => {
    return get(`/appointment/${id}`);
  },

  /**
   * Add new appointment
   *
   * @param commit
   * @param payload
   */
  [APPOINTMENT.ACTION_ADD]: ({commit}, payload) => {
    return post('/appointment', payload);
  },

  /**
   * Delete
   * @param commit
   * @param payload
   * @returns {*}
   */
  [APPOINTMENT.ACTION_DELETE]: ({commit}, payload) => {
    return del(`/appointment/${payload.id}`);
  },

  /**
   * Updated
   * @param commit
   * @param payload
   * @returns {*}
   */
  [APPOINTMENT.ACTION_UPDATE]: ({commit}, payload) => {
    return put(`/appointment/${payload.id}`, payload);
  },

  /**
   * Trend
   * @param commit
   * @param payload
   * @returns {*}
   */
  [APPOINTMENT.ACTION_TREND]: ({commit}, payload) => {
    const qs = queryString.stringify(payload);
    return get(`/appointment/trend?${qs}`);
  },

  [APPOINTMENT.ACTION_AGGREGATE]: ({commit}, payload) => {
    const qs = queryString.stringify(payload, {arrayFormat: 'bracket'});
    return get(`/appointment/aggregate?${qs}`);
  }
}



// WEBPACK FOOTER //
// ./src/store/appointment/actions.js